import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const ITestingDecorationsService = ( createDecorator('testingDecorationService'));
export { ITestingDecorationsService };
